import React from 'react';
import './FullScreenLoader.css';

function FullScreenLoader({ isLoading, message = "Loading...", children }) {
  if (isLoading) {
    return (
      <div className="fullscreen-loader-overlay">
        <div className="fullscreen-loader-content">
          <div className="loader-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
          <div className="loader-message">{message}</div>
        </div>
      </div>
    );
  }

  return children;
}

export default FullScreenLoader; 